export const TOGGLE_PAYER = 'headerMenu/TOGGLE_PAYER';
export const TOGGLE_PROVIDER = 'headerMenu/TOGGLE_PROVIDER';
export const TOGGLE_MY_ACCOUNT = 'headerMenu/TOGGLE_MY_ACCOUNT';
export const TOGGLE_NAV_ITEM = 'headerMenu/TOGGLE_NAV_ITEM';
